import ApiConfig from "../api/config/api-config";
import {
    ProductApi,
    ProductController$CreateProductJson,
    ProductController$ProductJson,
    ProductController$UpdateProductJson
} from "../api/generated/licensing-products";

export type Product = ProductController$ProductJson & { id: string };
export type CreateProduct = ProductController$CreateProductJson;
export type UpdateProduct = Omit<ProductController$UpdateProductJson, 'active'>;

export interface IProductService {
    list(): Promise<Product[]>;
    getByType(productType: string): Promise<Product>;
    create(product: CreateProduct): Promise<void>;
    update(productId: string, product: UpdateProduct): Promise<void>;
    linkToCreemProduct(productId: string, creemProductId: string): Promise<void>;
}

class ProductServiceImpl implements IProductService {

    constructor(private readonly _productApi: ProductApi) {
    }

    async list(): Promise<Product[]> {
        const result = await this._productApi.listAll();
        return result.items.map(item => ({...item, id: item.productId}));
    }

    async getByType(productType: string): Promise<Product> {
        const result = await this._productApi.getByType(productType);
        return {...result.item, id: result.item.productId};
    }

    async create(product: CreateProduct): Promise<void> {
        await this._productApi.create(product);
    }

    async update(productId: string, product: UpdateProduct): Promise<void> {
        await this._productApi.update(productId, {...product, active: product.isActive});
    }

    async linkToCreemProduct(productId: string, creemProductId: string): Promise<void> {
        await this._productApi.linkToCreemProduct(productId, {creemProductId});
    }

}

export const ProductService: IProductService = new ProductServiceImpl(
    new ProductApi(new ApiConfig()));
